import { Help } from '@shared/constants/help';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { userSelectors } from '@store/selectors/user.selectors';
import { StoreState } from '@store/store.state';
import { Store } from '@ngrx/store';
import { TranslateModule } from '@ngx-translate/core';
import { IconComponent } from '@shared/ui-components/icon/icon.component';
import { Footer } from '@shared/constants/footer';
import { CustomLinkDirective } from '@shared/directives/custom-link/custom-link.directive';
import { PortugalHelp } from '@shared/constants/portugal-help';

@Component({
  selector: 'ac-footer-links',
  standalone: true,
  templateUrl: './footer-links.component.html',
  styleUrls: ['./footer-links.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconComponent, TranslateModule, RouterLink, CustomLinkDirective],
})
export class FooterLinksComponent {
  protected readonly _emailSig = this._store.selectSignal(userSelectors.helpEmail);
  protected readonly _userSig = this._store.selectSignal(userSelectors.authUser);
  protected readonly _countrySig = this._store.selectSignal(userSelectors.country);
  protected readonly _spanishPhoneNumber: string = Help.PHONE;
  protected readonly _portugueseComercialPhoneNumber: string = PortugalHelp.PHONE_COMERCIAL;
  protected readonly _portugueseMeterReadingPhoneNumber: string = PortugalHelp.PHONE_METER_READING;
  protected readonly _portugueseOutagesPhoneNumber: string = PortugalHelp.PHONE;

  protected readonly _footerConstants = {
    acciona: Footer.ACCIONA,
    we: Footer.WE,
    solutions: Footer.SOLUTIONS,
    solutionsPt: Footer.SOLUTIONS_PT,
    currentNews: Footer.CURRENT_NEWS,
  };

  constructor(private readonly _store: Store<StoreState>) {}
}
